<template>
    <div class="news-main">
        <!-- 头部 -->
      <headers></headers>
        <section class="ban-bg">
            
        </section>
        <section class="ban">
            <div class="col">
                <h1 class="title1">及时有料并且专业的行业动态</h1>
            </div>
        </section>
        <div style="background: #fff; padding-bottom: 100px;">
            <section class="col news-con">
                <div class="news-l">
                    <div class="news-tab" id="news-tab">
                        <a href="javascript:;" data-type="0">全部</a>
                        <a href="javascript:;" data-type="1">行业新闻</a>
                        <a href="javascript:;" data-type="2">企业动态</a>
                    </div>
                    <ul class="news-list" id="news-list">
                        <!-- <li class="item">
                            <div class="i-left">
                                <div class="i-time">20/06/2021</div>
                            </div>
                            <div class="i-right">
                                <p class="i-title">商务部：持续优化政府服务，为展览业营造良好的发展环境</p>
                                <p class="i-txt">来源：</p>
                            </div>
                        </li> -->
                    </ul>
                    <div id="pages">
        
                    </div>
                </div>
                <div class="news-r">
                    <div class="news-t">最新文章</div>
                    <ul class="news-list2" id="news-list2">
                        <!-- <li>
                            <label>1</label>
                            <div>
                                <p>商务部：持续优化政府服务，为展览业营造良好的发展环境</p>
                                <span>20/06/2021</span>
                            </div>
                        </li> -->
                    </ul>
                    <div class="news-code">
                        <img src="../images/code-news.png" alt="">
                        <div>
                            <p>会展通讯社</p>
                            <span>及时、有料的会展新闻与行业动态！</span>
                        </div>
                    </div>
                </div>
                
            </section>
        </div>
        <!-- 尾部 -->
      <footers></footers>
      <!-- 右侧吸附客服咨询按钮 -->
      <contact></contact>
    </div>
</template>
    <script>
    import $ from 'jquery';
    import headers from '@/common/header';
    import footers from '@/common/Footer';
    import contact from '@/components/contact';
    var __spreadArrays = (this && this.__spreadArrays) || function () {
        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
        for (var r = Array(s), k = 0, i = 0; i < il; i++)
            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
                r[k] = a[j];
        return r;
    };
    var Pagination = /** @class */ (function () {
        function Pagination(options) {
            this.options = {
                // 容器
                element: '',
                // 样式类型
                type: 1,
                // 当前页
                pageIndex: 1,
                // 每页显示数量
                pageSize: 0,
                // 按钮数量
                pageCount: 9,
                // 总条数
                total: 0,
                // 上一页文字
                prevText: '',
                // 下一页文字
                nextText: '',
                // 输入框跳转
                jumper: false,
                // 单页隐藏
                singlePageHide: true,
                // 是否禁用
                disabled: false,
                /**
                 * @description 按钮事件回调
                 * @param index [number] 当前页码
                 */
                currentChange: function (index) { },
            };
            this.element = null;
            this.lis = [];
            this.home = null;
            this.last = null;
            this.prev = null;
            this.next = null;
            this.input = null;
            this.pageNum = 0;
            if (this.validate(options)) {
                this.init(options);
            }
        }
        Pagination.prototype.init = function (options) {
            this.setOptions(options);
            this.render();
        };
        Pagination.prototype.render = function () {
            var _this_1 = this;
            var _a;
            var _this = this, li, active;
            // 总页数
            this.pageNum = Math.ceil(this.options.total / this.options.pageSize);
            // 清空元素
            this.element.innerHTML = '';
            // 单页隐藏
            if (this.pageNum === 1 && this.options.singlePageHide)
                return;
            // 最大页码
            if (this.options.pageIndex > this.pageNum)
                this.options.pageIndex = this.pageNum;
            // 最小页码
            if (this.options.pageIndex <= 0)
                this.options.pageIndex = 1;
            // 主体容器
            var container = this.createElement('div', '_page_container');
            // 页码容器
            var ul = this.createElement('ul', ['_pages', "_pages_" + this.options.type]);
            // 禁用上一页
            var prev_disabled = this.options.pageIndex <= 1 ? ['_disabled_c'] : [];
            // 手势禁止
            if (this.options.pageIndex <= 1 && this.options.disabled)
                prev_disabled.push('_disabled');
            // 首页
            if (this.options.type <= 1) {
                this.home = this.createElement('li', __spreadArrays(['_home'], prev_disabled));
                this.home.innerText = '首页';
                this.home.addEventListener('click', function () {
                    if (_this_1.options.pageIndex > 1) {
                        _this_1.handleChangePage(1);
                    }
                });
                ul.appendChild(this.home);
            }
            // 上一页
            this.prev = this.createElement('li', __spreadArrays(['_prev_'], prev_disabled, (this.options.prevText ? ['_prev'] : ['_iconfont', 'iconzuo'])));
            // 上一页文字
            this.prev.innerText = this.options.prevText || '';
            // 上一页事件
            this.prev.addEventListener('click', function () {
                if (_this_1.options.pageIndex - 1 > 0) {
                    _this_1.handleChangePage(_this_1.options.pageIndex - 1);
                }
            });
            ul.appendChild(this.prev);
            // 区间值
            var between = this.getBetween();
            for (var i = 1; i <= this.pageNum; i++) {
                if (i >= between.min && i <= between.max) {
                    active = i === this.options.pageIndex ? ["_active_" + this.options.type] : [];
                    // 手势禁止
                    if (i === this.options.pageIndex && this.options.disabled)
                        active.push('_disabled');
                    li = this.createElement('li', __spreadArrays(["_pages_li_" + this.options.type], active));
                    li.innerText = i.toString();
                    li.setAttribute('data-index', i.toString());
                    li.addEventListener('click', function () {
                        if (this.dataset.index != _this.options.pageIndex) {
                            _this.handleChangePage(Number(this.dataset.index));
                        }
                    });
                    (_a = this.lis) === null || _a === void 0 ? void 0 : _a.push(li);
                    ul.appendChild(li);
                }
            }
            // 禁用下一页
            var next_disabled = this.options.pageIndex >= this.pageNum ? ['_disabled_c'] : [];
            // 手势禁止
            if (this.options.pageIndex >= this.pageNum && this.options.disabled)
                next_disabled.push('_disabled');
            // 下一页
            this.next = this.createElement('li', __spreadArrays(['_next_'], next_disabled, (this.options.nextText ? ['_next'] : ['_iconfont', 'iconGroup-'])));
            // 下一页文字
            this.next.innerText = this.options.nextText || '';
            // 下一页事件
            this.next.addEventListener('click', function () {
                if (_this_1.options.pageIndex < _this_1.pageNum) {
                    _this_1.handleChangePage(_this_1.options.pageIndex + 1);
                }
            });
            ul.appendChild(this.next);
            // 尾页
            if (this.options.type <= 1) {
                this.last = this.createElement('li', __spreadArrays(['_last'], next_disabled));
                this.last.innerText = '尾页';
                this.last.addEventListener('click', function () {
                    if (_this_1.options.pageIndex < _this_1.pageNum) {
                        _this_1.handleChangePage(_this_1.pageNum);
                    }
                });
                ul.appendChild(this.last);
            }
            container.appendChild(ul);
            // 输入框跳转
            if (this.options.jumper) {
                // 容器
                var jumper = this.createElement('div', '_jumper');
                // 总页码
                var count = this.createElement('span', '_count');
                count.innerText = "\u5171 " + this.pageNum + " \u9875";
                jumper.appendChild(count);
                var text_1 = this.createElement('span');
                text_1.innerText = '前往';
                jumper.appendChild(text_1);
                var value_1 = 0;
                // 输入框
                this.input = this.createElement('input', '_jumper_input');
                this.input.type = 'number';
                this.input.value = this.options.pageIndex.toString();
                this.input.setAttribute('min', '1');
                this.input.setAttribute('max', this.pageNum.toString());
                var handle = ['blur', 'keydown'];
                handle.forEach(function (v) {
                    _this_1.input.addEventListener(v, function (e) {
                        if (e.type === 'keydown' && e.keyCode !== 13) {
                            return;
                        }
                        value_1 = ~~this.value;
                        if (value_1 < 1)
                            value_1 = 1;
                        if (value_1 > _this.pageNum)
                            value_1 = _this.pageNum;
                        // @ts-ignore
                        this.value = value_1;
                        if (value_1 !== _this.options.pageIndex)
                            _this.handleChangePage(value_1);
                    });
                });
                jumper.appendChild(this.input);
                var text_2 = this.createElement('span');
                text_2.innerText = '页';
                jumper.appendChild(text_2);
                container.appendChild(jumper);
            }
            // 保存元素
            this.element.appendChild(container);
        };
        Pagination.prototype.handleChangePage = function (index) {
            var _this_1 = this;
            this.options.pageIndex = index;
            var mode;
            var around = ['home', 'last', 'prev', 'next'];
            around.forEach(function (param) {
                if (param === 'home' || param === 'prev') {
                    mode = index <= 1 ? 'add' : 'remove';
                }
                if (param === 'last' || param === 'next') {
                    mode = index >= _this_1.pageNum ? 'add' : 'remove';
                }
                if (_this_1[param]) {
                    _this_1[param].classList[mode]('_disabled_c');
                    _this_1.options.disabled && _this_1[param].classList[mode]('_disabled');
                }
            });
            // 区间值
            var between = this.getBetween();
            var betweenList = this.generateArray(between.min, between.max);
            // 排它
            for (var i = 0; i < this.lis.length; i++) {
                mode = betweenList[i] === index ? 'add' : 'remove';
                this.lis[i].classList[mode]("_active_" + this.options.type);
                this.lis[i].setAttribute('data-index', betweenList[i]);
                this.lis[i].innerText = betweenList[i].toString();
                this.options.disabled && this.lis[i].classList[mode]('_disabled');
            }
            // @ts-ignore 修改input值
            if (this.options.jumper)
                this.input.value = index;
            // 回调
            typeof this.options.currentChange === 'function' && this.options.currentChange(index);
        };
        Pagination.prototype.getBetween = function () {
            // 最小下标
            var min = this.options.pageIndex - Math.floor(this.options.pageCount / 2);
            // 最小下标最大值
            if (min > this.pageNum - this.options.pageCount) {
                min = this.pageNum - this.options.pageCount + 1;
            }
            // 最小值
            if (min <= 1)
                min = 1;
            // 最大下标
            var max = this.options.pageIndex + Math.floor(this.options.pageCount / 2);
            // 最大下标最小值
            if (max < this.options.pageCount)
                max = this.options.pageCount;
            // 最大值
            if (max > this.pageNum)
                max = this.pageNum;
            return { min: min, max: max };
        };
        Pagination.prototype.generateArray = function (start, end) {
            var arr = [];
            for (var i = start; i <= end; i++) {
                arr.push(i);
            }
            return arr;
        };
        Pagination.prototype.createElement = function (tag, classList) {
            var dom = document.createElement(tag);
            if (classList) {
                if (classList instanceof Array) {
                    classList.forEach(function (v) {
                        dom.classList.add(v);
                    });
                }
                else {
                    dom.classList.add(classList);
                }
            }
            return dom;
        };
        Pagination.prototype.validate = function (options) {
            if (!options)
                throw new Error('options of null');
            if (typeof options !== 'object')
                throw new Error('options not an object');
            if (!document.querySelector(options.element))
                throw new Error('element of null');
            ['type', 'pageIndex', 'pageSize', 'pageCount', 'total'].forEach(function (v) {
                if (options[v]) {
                    if (isNaN(options[v]))
                        throw new Error(v + " not an number");
                    if (v === 'pageCount' && options[v] % 2 === 0)
                        throw new Error(v + " not an odd number");
                }
            });
            return true;
        };
        Pagination.prototype.setOptions = function (options) {
            // 容器
            this.element = document.querySelector(options.element);
            for (var name_1 in options) {
                if (options[name_1] !== void 0) {
                    this.options[name_1] = isNaN(options[name_1]) ? options[name_1] : +options[name_1];
                }
            }
        };
        return Pagination;
    }());
    export default {
        components: {
            headers,
            footers,
            contact
        },
        mounted(){
            var _api = 'https://scm-member-api.expopaas.com'

        var _cateId = {
            '最新文章': '3',
            '全部': '0',
            '企业动态': '2',
            '行业动态': '1'
        }
        var data_news = {
            cateId: getUrlParamValue('type') || '0', //qydt：企业动态 hydt：行业动态 all：全部 news 最新文章
            page: 1, // 页码
            perPage: 8
        }
        
        get_news()
        get_news2()
        $('#news-tab').on('click','a',function(){
            // $(this).addClass('active').siblings('a').removeClass('active')
            data_news.cateId = $(this).attr('data-type')

            get_news()
        })

        function get_news(){
            $('[data-type='+data_news.cateId+']').addClass('active').siblings('a').removeClass('active')
            $.ajax({
                type: "get",
                url: _api+"/web/v1/article/info/getList",
                data: data_news,
                dataType: "json",
                success: function (res) {
                    // toast({ msg: res.msg })
                    if (res.code == 0) {
                        set_news(res.data.data)
                        if(res.data.total){
                            $('#pages').show()
                        }else{
                            $('#pages').hide()
                        }
                        
                        new Pagination({
                            element: '#pages', // 元素        
                            type: 1, // 样式类型，可选[1,2]      
                            pageIndex: data_news.page, // 初始页码       
                            pageSize: data_news.perPage, // 每页数量       
                            pageCount: 9, // 页码数量       
                            total: res.data.total, // 数据总条数        
                            jumper: false, // 显示输入框跳转        
                            singlePageHide: false, // 只有一页时不显示分页       
                            prevText: '<', // 上一页文字        
                            nextText: '>', // 下一页文字       
                            disabled: true, // 是否显示禁用        
                            currentChange: function(index) {
                                // 页码改变时回调         
                                // console.log(index);
                                data_news.page = index
                                get_news()
                            }
                        });
                    }else{

                    }
                }
            });
        }
        function get_news2(){
            $.ajax({
                type: "get",
                url: _api+"/web/v1/article/info/getList",
                data: {
                    cateId: '3', //qydt：企业动态 hydt：行业动态 all：全部 news 最新文章
                    pageNum: 1, // 页码
                    pageSize: 8
                },
                dataType: "json",
                success: function (res) {
                    // toast({ msg: res.msg })
                    if (res.code == 0) {
                        set_news2(res.data.data)

                    }else{

                    }
                }
            });
        }
        function set_news(list){
            var html = ''
            for(var i=0,j=list.length; i<j; i++){
                var item = list[i]
                html += '<li class="item">'+
                            '<div class="i-left">'+
                                '<div class="i-time">'+item.time+'</div>'+
                            '</div>'+
                            '<div class="i-right">'+
                                '<a class="i-title" href="newsDetail?id='+item.id+'&type='+data_news.cateId+'">'+item.title+'</a>'+
                                '<p class="i-txt">来源：'+item.cateName+'</p>'+
                            '</div>'+
                        '</li>'
            }
            $('#news-list').html(html)
        }

        function set_news2(list){
            var html = ''
            for(var i=0,j=list.length; i<j; i++){
                var item = list[i]
                html += '<li>'+
                            '<label class="'+(i<3?'active':'')+'">'+(i+1)+'</label>'+
                            '<div>'+
                                '<a href="newsDetail?id='+item.id+'&type=news">'+item.title+'</a>'+
                                '<span>'+item.time+'</span>'+
                            '</div>'+
                        '</li>'
            }
            $('#news-list2').html(html)
        }
        // 截取路径的参数
        function getUrlParamValue(name){
            var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
            var r = window.location.search.substr(1).match(reg);  //匹配目标参数
            if (r != null) return unescape(r[2]); return null; //返回参数值
        }
        function formatDate (value) {
            let date = new Date(value);
            if(date == 'Invalid Date'){
                return ''
            }
            let y = date.getFullYear();
            let MM = date.getMonth() + 1;
            MM = MM < 10 ? ('0' + MM) : MM;
            let d = date.getDate();
            d = d < 10 ? ('0' + d) : d;
            let h = date.getHours();
            h = h < 10 ? ('0' + h) : h;
            let m = date.getMinutes();
            m = m < 10 ? ('0' + m) : m;
            let s = date.getSeconds();
            s = s < 10 ? ('0' + s) : s;
            return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
        }
    }
}
    </script>
    <style>
        #pages{

        }
        ._page_container{
            text-align: left;
        }
        ._page_container ._pages li{
            font-weight: 400;
        }
    </style>


// WEBPACK FOOTER //
// src/page/news.vue